export let readTextFile = async (url) => {
  /*const response = await fetch(url);
  const txt = await response.text();
  return txt;*/
  let option = url.replace("/letters/", "");
  option = option.replace(".txt", "");
  switch (option) {
    case "article-accepted-authors":
      return `Estimado autor,

nos place comunicarle que su artículo con título '%TITULO%' ha sido aceptado para publicación en nuestra revista.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "article-accepted-chief-editors":
      return `Estimado editor-jefe,

el artículo con título '%TITULO%', ha sido aceptado para publicación en la revista.
      
Un saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "article-accepted-reviewers":
      return `Estimado revisor,

nos place comunicarle que el artículo con título '%TITULO%', del cual usted ha sido revisor, ha sido aceptado para publicación en nuestra revista.
      
Muchas gracias por su dedicación.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "article-major-authors":
      return `Estimado autor,

nos ponemos en contacto con usted porque su artículo con título '%TITULO%' ha sido evaluado por nuestros revisores y éste ha sido propuesto como Aceptado con Cambios Mayores.
      
Adjunto (o a través de nuestra plataforma) puede encontrar, de manera detallada, las sugerencias que cada revisor ha propuesto.
      
El siguiente paso es realizar una nueva versión de su artículo, considerando dichas consideraciones, y subirla a través de nuestra plataforma para una nueva revisión.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "article-major-reviewers":
      return `Estimado revisor,

le comunicamos que el artículo con título '%TITULO%', del cual usted ha sido revisor, ha sido propuesto como Aceptado con Cambios Mayores en nuestra revista.
      
En caso de haber indicado disponibilidad, comenzará una nueva ronda de revisiones próximamente.
      
Muchas gracias por su dedicación.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "article-minor-authors":
      return `Estimado autor,

nos ponemos en contacto con usted porque su artículo con título '%TITULO%' ha sido evaluado por nuestros revisores y éste ha sido propuesto como Aceptado con Cambios Menores.
      
Adjunto (o a través de nuestra plataforma) puede encontrar, de manera detallada, las sugerencias que cada revisor ha propuesto.
      
El siguiente paso es realizar una nueva versión de su artículo, considerando dichas consideraciones, y subirla a través de nuestra plataforma para una nueva revisión.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "article-minor-reviewers":
      return `Estimado revisor,

le comunicamos que el artículo con título '%TITULO%', del cual usted ha sido revisor, ha sido propuesto como Aceptado con Cambios Menores en nuestra revista.
      
En caso de haber indicado disponibilidad, comenzará una nueva ronda de revisiones próximamente.
      
Muchas gracias por su dedicación.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "article-rejected-authors":
      return `Estimado autor,

lamentamos comunicarle que su artículo con título '%TITULO%' no ha sido aceptado para publicación en nuestra revista. Adjunto (o a través de nuestra plataforma) puede encontrar, de manera detallada, las sugerencias de cada revisor, por si es de utilidad.
      
Le animamos a que siga enviando sus futuros trabajos.

Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "article-rejected-chief-editors":
      return `Estimado editor-jefe,

el artículo con título '%TITULO%', ha sido rechazado para publicación en la revista.
      
Un saludo,`;
      break;
    case "article-rejected-reviewers":
      return `Estimado revisor,

le comunicamos que el artículo con título '%TITULO%', del cual usted ha sido revisor, no ha sido aceptado para publicación en nuestra revista. 
      
Muchas gracias por su dedicación.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "create-user":
      return `Estimado %USUARIO%, 

gracias por registrarse en la Revista Española de Ciencias Farmaceúticas. 
      
Los datos con lo que usted se ha registrado son los siguientes: 
      
Nombre: %USUARIO%
Email: %EMAIL%
Contraseña: %PASSWORD%
Institución: %INSTITUCION%
Firma: %FIRMA%
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "propose-editor":
      return `Estimado %USUARIO%,

un editor jefe le ha seleccionado como editor del artículo con título '%TITULO%'. Por favor, ingrese en nuestra plataforma web para indicar si acepta o rechaza dicha solicitud.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "propose-reviewer":
      return `Estimado %USUARIO%,

nos ponemos en contacto con usted porque le hemos seleccionado como revisor del artículo con título '%TITULO%'. Por favor, ingrese en nuestra plataforma web para indicar si acepta o rechaza la solicitud de revisión.
      
En caso de aceptar la propuesta, dispondrá de los manuscritos de los autores para su revisión, en formatos DOCX y PDF, así como el listado con las figuras para su descarga. Tras la lectura y análisis de los trabajos presentados, deberá enviar, también a través de la plataforma, su carta para los autores (DOCX), su carta para los editores (DOCX), y la decisión de si dicho trabajo sería publicable o no en nuestra revista.
      
Le agradecemos enormemente el esfuerzo que este trabajo conlleva, y su confianza en nuestra revista.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "reviewer-accepts":
      return `Estimado %USUARIO%,

gracias por ser revisor del artículo con título '%TITULO%'.
      
Le recordamos que en nuestra plataforma podrá acceder a los manuscritos de los autores para su revisión, en formatos DOCX y PDF, así como el listado con las figuras para su descarga. Tras la lectura y análisis de los trabajos presentados, deberá enviar, también a través de la plataforma, su carta para los autores (DOCX), su carta para los editores (DOCX), y la decisión de si dicho trabajo sería publicable o no en nuestra revista.
      
Quedamos a la espera de sus sugerencias.

Un cordial saludo y gracias,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "reviewer-accepts-editor":
      return `Estimado %USUARIO%,

como editor del artículo con título '%TITULO%', le comunicamos que %REVISOR% ha aceptado la propuesta de ser revisor.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "reviewer-no-second-round":
      return `Estimado %USUARIO%,

ha seleccionado no continuar con la revisión del artículo con título '%TITULO%', en caso de que éste sea considerado para una nueva ronda de revisiones.
      
Agradecemos su disposición y esperamos volver a trabajar juntos en el futuro.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "reviewer-rejects":
      return `Estimado %USUARIO%,

Lamentamos que no pueda ayudarnos con la revisión del artículo con título '%TITULO%'.
      
De todas formas agradecemos su disposición y esperamos volver a trabajar juntos en el futuro.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "reviewer-rejects-editor":
      return `Estimado %USUARIO%,

como editor del artículo con título '%TITULO%', le comunicamos que %REVISOR% ha rechazado la propuesta de ser revisor.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "reviewer-thanks":
      return `Estimado %USUARIO%,

Agradecemos el tiempo que ha dedicado para la revisión del artículo con título '%TITULO%'.
      
Le haremos llegar sus consideraciones a los autores del artículo y las valoraremos a la hora de decidir la publicación del trabajo en nuestra revista. 
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "reviewer-thanks-editor":
      return `Estimado %USUARIO%,

como editor del artículo con título '%TITULO%', le comunicamos que %REVISOR% ha enviado su revisión.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "send-article":
      return `Estimado %USUARIO%, 

hemos recibido su solicitud para la publicación del artículo con título '%TITULO%', en el que usted figura como autor.
      
Tras un proceso de revisión, le comunicaremos si su trabajo es apto para publicación, y si es necesario realizar cambios.
      
Puede consultar el estado del artículo en cualquier momento a través de la plataforma web.
      
Un cordial saludo y gracias por la confianza.

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "send-article-chief-editor":
      return `Estimado editor jefe, 

le informamos de que el sistema acaba de recibir el artículo con título '%TITULO%' para una primera revisión.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "send-article-reviewed-authors":
      return `Estimado %USUARIO%, 

hemos recibido la nueva versión de su artículo con título '%TITULO%', la cual será sometida a una nueva ronda de revisiones.
      
Al finalizar este proceso, le comunicaremos la decisión final sobre la publicación de su trabajo en nuestra revista.
      
Puede consultar el estado del artículo en cualquier momento a través de la plataforma web.
      
Un cordial saludo y gracias por la confianza.

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "send-article-reviewed-editor":
      return `Estimado %USUARIO%,

como editor del artículo con título '%TITULO%', le comunicamos que los autores han enviado una nueva versión.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
    case "send-article-reviewed-reviewers":
      return `Estimado revisor, 

hemos recibido la nueva versión del artículo con título '%TITULO%', del cual usted es revisor.
      
El procedimiento de revisión durante esta nueva ronda es el mismo: Dispone en nuestra plataforma de los manuscritos de los autores para su revisión, en formatos DOCX y PDF, así como el listado con las figuras para su descarga. Tras la lectura y análisis de los trabajos presentados, deberá enviar, también a través de la plataforma, su carta para los autores (DOCX), su carta para los editores (DOCX), y la decisión de si dicho trabajo sería definitivamente publicable o no en nuestra revista.
      
Le agradecemos enormemente el esfuerzo que este trabajo conlleva, y su confianza en nuestra revista.
      
Un cordial saludo,

Acceso a la plataforma: https://rescifar.farmaceuticosdesevilla.es`;
      break;
  }
};
